import script from "./Signin.vue?vue&type=script&setup=true&lang=js"
export * from "./Signin.vue?vue&type=script&setup=true&lang=js"

import "./Signin.vue?vue&type=style&index=0&id=353dcaad&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-353dcaad"]])

export default __exports__